import Axios from "axios";

const axiosExtra = {
  setBaseURL(baseURL) {
    this.defaults.baseURL = baseURL;
  },
  setHeader(name, value, scopes = "common") {

    if (!name.appId) {
      return
    }
    for (let key in name) {
      this.defaults.headers[key] = name[key]
    }
    // for (let scope of Array.isArray(scopes) ? scopes : [scopes]) {
    //   if (!value) {
    //     delete this.defaults.headers[scope][name];
    //     return;
    //   }
    //   this.defaults.headers[scope][name] = value;
    // }
  },
  setToken(token, type, scopes = "common") {
    const value = !token ? null : (type ? type + " " : "") + token;
    this.setHeader("Authorization", value, scopes);
  },
  onRequest(fn) {
    this.interceptors.request.use(config => fn(config) || config);
  },
  onResponse(fn) {
    this.interceptors.response.use(response => fn(response) || response);
  },
  onRequestError(fn) {
    this.interceptors.request.use(
      undefined,
      error => fn(error) || Promise.reject(error)
    );
  },
  onResponseError(fn) {
    this.interceptors.response.use(
      undefined,
      error => fn(error) || Promise.reject(error)
    );
  },
  onError(fn) {
    this.onRequestError(fn);
    this.onResponseError(fn);
  }
};

const extendAxiosInstance = axios => {
  for (let key in axiosExtra) {
    axios[key] = axiosExtra[key].bind(axios);
  }
};

const axios = Axios.create();
axios.CancelToken = Axios.CancelToken;
axios.isCancel = Axios.isCancel;
axios.create = Axios.create;

extendAxiosInstance(axios);

export default axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js